import { render, staticRenderFns } from "./AllPatients.vue?vue&type=template&id=80550092&scoped=true"
import script from "./AllPatients.vue?vue&type=script&lang=js"
export * from "./AllPatients.vue?vue&type=script&lang=js"
import style0 from "./AllPatients.vue?vue&type=style&index=0&id=80550092&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80550092",
  null
  
)

export default component.exports